import Vue from 'vue'
import Router from 'vue-router'
// 研修营 9 个新页面。只拼到路由表末尾，不改上面的原有路由。
import { researchCampRouterMap } from './researchCamp'

// 路由组件按需加载，减小首屏入口体积
const register = () => import('../views/loginPage/register')
const loginPage = () => import('../views/loginPage/loginPage')
const homePage = () => import('../views/home/home')
const trainDetails = () => import('../views/xwzy/trainDetails.vue')
const department = () => import('../views/xwzy/department.vue')
const journeyReport = () => import('../views/journeyReport/journeyReport.vue')
const AIFV = () => import('../views/AIFV/AIFV.vue')
const AIFVONEPAGE = () => import('../views/AIFV/AIFVONEPAGE.vue')
const courserDetailsXwzy = () => import('../views/course/courserDetailsXwzy.vue')
const trainNone = () => import('../views/training/trainNoneData.vue')
// 后台配置路由，暂时先手写
const pcInfos = () => import('@/views/home/pcInfos')
const followPage = () => import('@/views/loginPage/followPage.vue')
const ssotempPage = () => import('@/views/loginPage/ssotempPage')
const articleDetails = () => import('@/views/article/articleDetails')
const longTimeLogin = () => import('@/views/loginPage/longTimeLogin')
const agreeDetailPage = () => import('@/views/person/agreeDetailPage.vue')
const fontBase = () => import('@/views/person/fontBase.vue')
const agreeList = () => import('@/views/person/agreeList.vue')

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject) }
  return originalPush.call(this, location).catch(err => err)
}
export const constantRouterMap = [
  { path: '/', redirect: '/loginPage' },
  {
    path: '/register',
    name: '注册页',
    meta: {
      moduleName: '注册'
    },
    component: register
  },
  {
    path: '/loginVerification',
    name: '登录校验',
    meta: {
      moduleName: '登录校验'
    },
    component: () => import('../views/loginPage/loginVerification.vue')
  },
  {
    path: '/linkExpired',
    name: '链接失效',
    meta: {
      moduleName: '链接失效'
    },
    component: () => import('../views/loginPage/linkExpired.vue')
  },
  {
    path: '/appealPage',
    name: '申诉页',
    meta: {
      moduleName: '申诉页'
    },
    component: () => import('../views/loginPage/appealPage.vue')
  },
  {
    path: '/loginPage',
    name: '登录页',
    meta: {
      moduleName: '登录'
    },
    component: loginPage
  },
  {
    path: '/followPage',
    name: '关注二维码',
    meta: {
      moduleName: '关注二维码'
    },
    component: followPage
  },
  {
    path: '/home',
    name: '首页',
    meta: {
      moduleName: '首页'
    },
    component: homePage
  },
  {
    path: '/trainNone',
    name: '训练营判空',
    meta: {
      moduleName: '训练营'
    },
    component: trainNone
  },
  {
    path: '/xwzy/trainDetails',
    name: '行稳致远',
    meta: {
      moduleName: '行稳致远'
    },
    component: trainDetails
  },
  {
    path: '/xwzy/articleDetails',
    name: '行稳致远 - 文献详情',
    meta: {
      moduleName: '行稳致远'
    },
    component: articleDetails
  },
  {
    path: '/xwzy/department',
    name: '大主任',
    meta: {
      moduleName: '行稳致远'
    },
    component: department
  },
  {
    path: '/xwzy/journeyReport',
    name: '旅程报告',
    meta: {
      moduleName: '行稳致远'
    },
    component: journeyReport
  },
  {
    path: '/xwzy/AIFV',
    name: 'AIFVonepage',
    meta: {
      moduleName: 'AIFV'
    },
    component: AIFV
  },
  {
    path: '/AIFVONEPAGE',
    name: 'AIFVonepage单页',
    meta: {
      moduleName: 'AIFV'
    },
    component: AIFVONEPAGE
  },
  {
    path: '/courserDetailsXwzy',
    name: '课程详情',
    meta: {
      moduleName: '行稳致远'
    },
    component: courserDetailsXwzy
  },
  {
    path: '/pcInfos',
    name: 'iEP-中国电生理术者充电站',
    meta: {
      moduleName: 'iEP-中国电生理术者充电站'
    },
    component: pcInfos
  },
  {
    path: '/sso/tempPage',
    name: 'sso登陆中转页',
    meta: {
      moduleName: 'sso登陆中转页'
    },
    component: ssotempPage
  },
  {
    path: '/longTimeLogin',
    name: '登录',
    meta: {
      moduleName: '登录'
    },
    component: longTimeLogin
  },
  {
    path: '/agreeDetailPage',
    name: '协议详情',
    meta: {
      moduleName: '协议详情'
    },
    component: agreeDetailPage
  },
  {
    path: '/agreeList',
    name: '用户授权',
    meta: {
      moduleName: '用户授权'
    },
    component: agreeList
  },
  {
    path: '/fontBase',
    name: '字体许可证',
    meta: {
      moduleName: '字体许可证'
    },
    component: fontBase
  },
  {
    path: '/JJMC_ECGenius',
    name: '室早心电图',
    meta: { moduleName: 'JJMC_ECGenius' },
    component: () => import('../views/JJMC_ECGenius/index.vue'),
  },
  {
    path: '/informationDisplay',
    name: '用户展示',
    meta: { moduleName: '用户展示' },
    component: () => import('../views/informationDisplay/index.vue'),
  },
  {
    path: '/filePreview',
    name: '文件预览',
    meta: { moduleName: '文件预览' },
    component: () => import('../views/pfa/filePreview.vue'),
  },
].concat(researchCampRouterMap)
export default new Router({
  routes: constantRouterMap,
  mode: 'history',
  base: process.env.BASE_URL
})



// WEBPACK FOOTER //
// ./src/router/index.js